import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
  imprestApplications,
  leaveApplications,
  leaveApplicationsByUser,
  staffClaimApplications,
  staffClaimApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import {
  LeaveApplicationsColumns,
  imprestApplicationsColumns,
  staffClaimApplicationsColumns,
} from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import StaffClaimApplicationForm from "./form";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";

const base_url = HRService.uri;
const actions = {
  entity: " Staff Claim Approvals",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  viewStaffClaimsLines: {
    key: "ASSIGN_TASK",
    button_name: "View Claim Lines",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  submitStaffClaim: {
    key: "MARK_TASK_DONE",
    button_name: "Submit Staff Claim",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],

  
  },
  dataObject: {
    ignoreFields:["disbursementType"],
    objectName: "staffClaimApplicationsByUser",
    parameters: "",
  },
  showStatus: true,
};
function StaffClaimsByUserTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTableForJson
          title="Staff Claims"
          subtitle="View your Staff Claims, create or edit it"
          //columns={staffClaimApplicationsColumns}
          FormComponent={StaffClaimApplicationForm}
          // query={staffClaimApplicationsByUser}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default StaffClaimsByUserTable;
